<template>
    <div id="view-toggle" class="p-desktop row" :style="`bottom: -${toggleBottom}px`">
        <div id="control-toggle" class="flex-center">
            <div id="controls">

                <!-- View type toggle/close icon -->
                <div id="icons" class="btn flex-center" @click="ToggleViewTypeControls()">
                    <img id="icon" src="@/assets/Images/Settings/IconProjectsView.png" alt="Icon - Projects View" title="Projects View" width="35" height="19" v-if="!showViewTypes"/>
                    <img id="icon" src="@/assets/Images/Close.png" alt="Icon - Close" title="Close" width="28" height="28" v-else/>
                </div>

                <div id="toggler-wrap" class="flex-center">
                    <div class="flex-center" v-if="showViewTypes">
                        <Type
                            view="Timeline"
                            :current="projectViewType.view"
                            @toggle="$emit('toggle', $event)"
                        />
                        <div id="toggler">
                            <div id="bar"></div>
                            <div id="scrubber" :style="ScrubberPosition()"></div>
                        </div>
                        <Type
                            view="List"
                            :current="projectViewType.view"
                            @toggle="$emit('toggle', $event)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PROJECT_VIEW_TYPES } from "@/assets/JS/Assets.js";
import Type from "@/components/Projects/ViewToggle/Type.vue";

export default {
    name: "ViewToggle",
    props: { projectViewType: Object },
    components: { Type },
    data: () => ({
        showViewTypes: false,
        toggleBottom: 165
    }),
    methods: {
        ScrubberPosition: function() {
            return this.projectViewType.view === "Timeline" ? "left: 0" : "right: 0";
        },
        ToggleViewTypeControls: function() {
            this.showViewTypes = !this.showViewTypes;
            this.toggleBottom = this.showViewTypes ? 80 : 165;
        }
    },
    emits: [ "toggle" ]
};
</script>